import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  inject,
  Input,
  model,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DialogCloseRef } from './dialog.component.close-ref';

@Component({
  standalone: true,
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css'],
  imports: [CommonModule],
})
export class DialogComponent implements OnChanges {
  private readonly dialogCloseRef = inject(DialogCloseRef);
  @Input() centered = true;

  isOpen = model(false);
  @Input() testId!: string;
  @Output() dialogClosed = new EventEmitter();

  @HostListener('click', ['$event'])
  onOverlayClick(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.onClose(event);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isOpen) {
      if (this.isOpen()) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
  }

  onClose(e: MouseEvent) {
    e.preventDefault();
    this.isOpen.set(false);
    this.dialogClosed.emit();
    this.dialogCloseRef.close(this.testId || '');
  }
}
